// Texto 28 (B6/B7, REGRAS 10.9): o passo a passo de cada aba, em três lugares com a mesma explicação:
//   · um ⓘ pequeno no topo da aba (ao lado do olhinho), como nos sites;
//   · o link "Como usar esta aba" no fim da aba;
//   · Ajustes › Abas › [aba] › Como usar esta aba.
// A explicação é a página da aba no Guia (Ajustes › Como usar › Guia das abas). Aba sem página pronta não mostra nada.
import { Pressable, Text } from 'react-native';
import { router } from 'expo-router';
import type { AbaId } from '../store/types';
import { idAba, paginaDaAba } from '../lib/guia/conteudo';
import { pedirPaginasAjustes } from '../lib/guia/destaque';
import { t } from '../lib/i18n';
import { C } from './theme';

/** A aba tem o passo a passo pronto no Guia? */
export const temComoUsar = (id: AbaId) => { try { return paginaDaAba(id).pronta; } catch { return false; } };
/** Abre o passo a passo da aba (em Ajustes, com ‹ para voltar ao Guia). */
export function abrirComoUsar(id: AbaId) {
  pedirPaginasAjustes(['comousar', 'guia:' + idAba(id)]);
  router.navigate('/ajustes' as any);
}

/** ⓘ no topo da aba. */
export function BotaoInfo({ aba }: { aba: AbaId }) {
  if (!temComoUsar(aba)) return null;
  return (
    <Pressable onPress={() => abrirComoUsar(aba)} hitSlop={8} accessibilityRole="button" accessibilityLabel={t('Como usar esta aba')}
      style={{ width: 38, height: 38, borderRadius: 19, backgroundColor: C.card, alignItems: 'center', justifyContent: 'center' }}>
      <Text style={{ color: C.sub, fontSize: 18, fontWeight: '700' }}>ⓘ</Text>
    </Pressable>
  );
}

/** "Como usar esta aba" no fim da aba. */
export function LinkComoUsar({ aba }: { aba: AbaId }) {
  if (!temComoUsar(aba)) return null;
  return (
    <Pressable onPress={() => abrirComoUsar(aba)} hitSlop={8} accessibilityRole="link" style={{ alignSelf: 'center', paddingVertical: 10 }}>
      <Text style={{ color: C.sub, fontSize: 13, textDecorationLine: 'underline' }}>ⓘ {t('Como usar esta aba')}</Text>
    </Pressable>
  );
}
